export const verifyGST = async (gstNumber) => {
  const apiKey = "665b60ad-2b2a-4bd7-bde2-ab106e624c57";
  const url = `https://taxpayer.irisgst.com/api/search?gstin=${gstNumber}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        accept: "application/json",
        apikey: apiKey,
      },
    });

    const result = await response.json();

    return result;
  } catch (error) {
    console.error("Error verifying GST number: ", error);
    throw error;
  }
};

/**
 * Function to extract the state code from a GST number.
 * @param {string} gstNumber - The GST number.
 * @returns {string|null} - The state code if valid, otherwise null.
 */
export const getStateCodeFromGST = (gstNumber) => {
  if (!gstNumber || typeof gstNumber !== "string" || gstNumber.length < 2) {
    console.error("Invalid GST number provided:", gstNumber);
    return null;
  }

  // Extract the first two characters of the GST number as the state code
  const stateCode = gstNumber.substring(0, 2);

  // Validate that the extracted state code is numeric and within the valid range
  const validStateCodes = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "97",
    "98",
  ];

  if (!validStateCodes.includes(stateCode)) {
    console.error("Invalid state code extracted from GST number:", stateCode);
    return null;
  }

  return stateCode;
};

export default verifyGST;
